// Recovered compiled webpack factory 20753. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { L: () => l, d: () => s });
  var n = r(73314),
    a = r(49636);
  let o = "_sentryScope",
    i = "_sentryIsolationScope";
  function s(e, t, r) {
    e &&
      ((0, n.my)(
        e,
        i,
        (function (e) {
          try {
            let t = a.O.WeakRef;
            if ("function" == typeof t) return new t(e);
          } catch {}
          return e;
        })(r),
      ),
      (0, n.my)(e, o, t));
  }
  function l(e) {
    return {
      scope: e[o],
      isolationScope: (function (e) {
        if (e) {
          if ("object" == typeof e && "deref" in e && "function" == typeof e.deref)
            try {
              return e.deref();
            } catch {
              return;
            }
          return e;
        }
      })(e[i]),
    };
  }
}
